import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { UnauthLayoutComponentComponent } from '@/app/layouts/unauth-layout-component/unauth-layout-component.component';
import { getBaseHref } from '@/app/app.config';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  protected unauthenticatedRootPage = false;

  constructor(
    protected override readonly router: Router,
    private location: PlatformLocation,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // Check if the current route is under the UnauthLayoutComponent
    const isUnauthRoute =
      route.parent?.component === UnauthLayoutComponentComponent;

    if (!this.authenticated) {
      // If it's not an unauth route, redirect to login
      if (!isUnauthRoute) {
        await this.keycloak.login({
          redirectUri:
            window.location.origin + getBaseHref(this.location) + state.url,
        });
        return false;
      }
      // Allow access to unauth routes when not authenticated
      return true;
    }

    // User is authenticated
    if (isUnauthRoute) {
      // Redirect authenticated users away from unauth routes (e.g., to home)
      await this.router.navigate(['/home']);
      return false;
    }

    const requiredRoles = route.data['roles'];

    // What's happening here? Why would we return true if there are no required roles?
    if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
      return true;
    }

    const hasRequiredRoles = requiredRoles.some((role: string) =>
      this.roles.includes(role)
    );
    console.log(hasRequiredRoles);

    if (!hasRequiredRoles) {
      await this.router.navigate(['/home']);
      return false;
    }

    return hasRequiredRoles;
  }
}
